import { Button, Input, message, Modal, Popconfirm, Tooltip } from "antd";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { CiEdit } from "react-icons/ci";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import YukxatiAdd_modal from "../../YukXati/YukXatiAdd/YukxatiAdd_modal";
import { BsCopy } from "react-icons/bs";
import { MdDeleteOutline, MdOutlineUnarchive } from "react-icons/md";
import YukxatiEdit_modal from "../../YukXati/YukXatiAdd/YukxatiEdit_modal";
import axiosInstance from "../../../Components/axiosInstance/AxiosInstance";
import CustomerActions from "../../../Components/Customers/CustomerActions";
import { TbEyeEdit } from "react-icons/tb";
import { OneCustomer } from "../../../Stores/Customers/OneCustomer";
import { IoColorPaletteOutline, IoPersonAddOutline } from "react-icons/io5";
import ExcelDownloaderYukxati from "../../../Components/Customers/ExcelDownloader/ExcelDownloaderYukxati";
import { StoreProfileInfo } from "../../../Stores/ProfileInfo/StoreProfileInfo";
export default function Yukxatlari() {
  // let { data: productsNames } = StoreProfileInfo();
  const { data, deleteYKX, archiveYKX, putColorYKX } = OneCustomer();
  let navigate = useNavigate();
  const location = useLocation(); // Gets the current location object
  let [isModalOpen, setIsModalOpen] = useState(false);
  let [isModalOpenEdit, setIsModalOpenEdit] = useState(false);
  let [colorModalOpen, setColorModalOpen] = useState(false);
  let [colorYKX, setColorYKX] = useState(null);
  let [filterDate, setFilterDate] = useState(null);
  let [filterName, setFilterName] = useState(null);
  let [ykxlar, setYkxlar] = useState([]);

  const colors = [
    // Stone
    [
      "#FAFAF9",
      "#F5F5F4",
      "#E7E5E4",
      "#D6D3D1",
      "#A8A29E",
      "#78716C",
      "#57534E",
      "#44403C",
      "#292524",
      "#1C1917",
      "#0C0A09",
    ],

    // Sky
    [
      "#F0F9FF",
      "#E0F2FE",
      "#BAE6FD",
      "#7DD3FC",
      "#38BDF8",
      "#0EA5E9",
      "#0284C7",
      "#0369A1",
      "#075985",
      "#0C4A6E",
      "#082F49",
    ],

    // Red
    [
      "#FEF2F2",
      "#FEE2E2",
      "#FECACA",
      "#FCA5A5",
      "#F87171",
      "#EF4444",
      "#DC2626",
      "#B91C1C",
      "#991B1B",
      "#7F1D1D",
      "#450A0A",
    ],

    // Orange
    [
      "#FFF7ED",
      "#FFEDD5",
      "#FED7AA",
      "#FDBA74",
      "#FB923C",
      "#F97316",
      "#EA580C",
      "#C2410C",
      "#9A3412",
      "#7C2D12",
      "#431407",
    ],

    // Yellow
    [
      "#FEFCE8",
      "#FEF9C3",
      "#FEF08A",
      "#FDE047",
      "#FACC15",
      "#EAB308",
      "#CA8A04",
      "#A16207",
      "#854D0E",
      "#713F12",
      "#422006",
    ],

    // Amber
    [
      "#FFFBEB",
      "#FEF3C7",
      "#FDE68A",
      "#FCD34D",
      "#FBBF24",
      "#F59E0B",
      "#D97706",
      "#B45309",
      "#92400E",
      "#78350F",
      "#451A03",
    ],

    // Green
    [
      "#F0FDF4",
      "#DCFCE7",
      "#BBF7D0",
      "#86EFAC",
      "#4ADE80",
      "#22C55E",
      "#16A34A",
      "#15803D",
      "#166534",
      "#14532D",
      "#052E16",
    ],
  ];

  function calculateProductTotals(data) {
    const totals = {};

    data.forEach((item) => {
      const productName = item.name;
      const tonnage = item.tonna;

      if (totals[productName]) {
        totals[productName] += Number(tonnage);
      } else {
        totals[productName] = Number(tonnage);
      }
    });

    return totals;
  }
  let productsNames = () => {
    return [...new Set(data?.ykx?.map((p) => p.name))];
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "+") {
        event.preventDefault(); // Prevent browser zoom-in
        setIsModalOpen(!isModalOpen);
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  useEffect(() => {
    if (data?.ykx) {
      setYkxlar([...data?.ykx]);
    }
  }, [data]);

  useEffect(() => {
    if (!data?.ykx) return;
    let ykxlarCopy = [...data?.ykx];

    if (filterDate && filterDate?.length !== 0) {
      ykxlarCopy = ykxlarCopy.filter(
        (el) => filterDate == moment(el?.date).format("DD.MM.YYYY")
      );
    }
    if (filterName) {
      ykxlarCopy = ykxlarCopy.filter(
        (el) => filterName == el?.name || filterName == "Jami"
      );
    }
    setYkxlar([...ykxlarCopy]);
  }, [filterDate, filterName]);

  return (
    <div className="flex flex-col gap-2 py-2">
      <Button
        onClick={() => {
          // navigate("/yukxati/new/" + id);
          setIsModalOpen(true);
        }}
        variant="solid"
        icon={<CiEdit className="font-[30px]" />}
      >
        Yuk xati qo'shish
      </Button>
      <YukxatiAdd_modal
        setIsModalOpen={setIsModalOpen}
        isModalOpen={isModalOpen}
      />
      <Modal
        style={{ top: "10px" }}
        title="Ranglar"
        open={colorModalOpen}
        //   loading={loadVagon}
        onOk={() => {
          setColorModalOpen(false);
        }}
        onCancel={() => {
          console.log("Modal closed via Cancel button or close icon.");
          setColorModalOpen(false);
        }}
        footer={[
          <Button
            key="submit"
            type="primary"
            onClick={() => {
              setColorModalOpen(false);
            }}
          >
            Saqlash
          </Button>,
        ]}
      >
        <div>
          <div className="flex flex-col items-center gap-1">
            {colors.map((el) => {
              return (
                <div className="flex flex-row items-center gap-1">
                  {el.map((col) => (
                    <button
                      onClick={() => {
                        putColorYKX(colorYKX, col);
                      }}
                      style={{
                        background: col,
                        border: "1px solid #000",
                      }}
                      className={
                        " w-[40px] h-[40px] rounded-sm  sm:rounded-md "
                      }
                    ></button>
                  ))}
                </div>
              );
            })}
          </div>
        </div>
      </Modal>

      {/* EDIT YUKXATI */}
      <YukxatiEdit_modal
        setIsModalOpen={setIsModalOpenEdit}
        isModalOpen={isModalOpenEdit}
      />
      <table
        style={{
          borderCollapse: "collapse",
          width: "100%",
        }}
        border="1"
        className="text-[14px]"
        cellpadding="10"
      >
        <tr>
          <th className="text-[14px] text-left text-bold border border-gray-400 px-4 py-2"></th>

          <th className="text-[14px] text-right text-bold border border-gray-400 px-4 py-2">
            <select
              onChange={(e) => {
                console.log(e.target.value);
                setFilterName(e?.target?.value);
              }}
            >
              <option>Jami</option>
              {productsNames()?.map((el) => {
                return <option key={el}>{el}</option>;
              })}
            </select>{" "}
          </th>
          <th className="text-[14px] text-left text-bold border border-gray-400 px-4 py-2">
            {ykxlar
              ?.reduce((acc, curr) => {
                return acc + Number(curr?.tonna);
              }, 0)
              ?.toFixed(2)}
            Tn
          </th>
          <th className="text-[14px] text-left text-bold border border-gray-400 px-4 py-2">
            <Input
              className="w-[100px]"
              type="text"
              onChange={(e) => {
                console.log(e.target.value);
                if (e.target.value.length > 0) {
                  setFilterDate(e.target.value);
                } else {
                  setFilterDate(null);
                }
              }}
            />
          </th>
          <th className="text-[14px] text-left text-bold border border-gray-400 px-4 py-2"></th>
          <th className="text-[14px] text-left text-bold border border-gray-400 px-4 py-2"></th>
        </tr>
        <tr>
          <th className="text-[14px] text-left text-bold border border-gray-400 px-4 py-2 border border-gray-400 px-4 py-2">
            №
          </th>
          <th className="text-[14px] text-left text-bold border border-gray-400 px-4 py-2">
            Юк номи
          </th>
          <th className="text-[14px] text-left text-bold border border-gray-400 px-4 py-2">
            Соф огирлик
          </th>

          <th className="text-[14px] text-left text-bold border border-gray-400 px-4 py-2">
            Sana
          </th>
          <th className="text-[14px] text-left text-bold border border-gray-400 px-4 py-2">
            Izox
          </th>
          <th className="text-[14px] text-left text-bold border border-gray-400 px-4 py-2">
            <ExcelDownloaderYukxati data={data?.ykx} />
          </th>
        </tr>
        {ykxlar
          ?.sort(
            (a, b) =>
              moment(a.date, "YYYY-MM-DD") - moment(b.date, "YYYY-MM-DD")
          )
          ?.map((ykx, i) => {
            return (
              <tr
                style={{
                  background: ykx?.is_dk
                    ? "#393E46"
                    : ykx?.bgColor
                    ? ykx?.bgColor
                    : "",
                  color: ykx?.is_dk ? "#bfbfbf" : "",
                  // background: ykx?.bgColor && !ykx?.is_dk ? ykx?.bgColor : "",
                }}
              >
                <td className="text-[14px] text-left text-bold border border-gray-400 px-4 py-1">
                  <Link to={"/yukxati/" + ykx?.id}>{ykx?.id}</Link>
                </td>
                <td
                  style={{
                    textTransform: ykx?.is_dk ? "line" : "",
                  }}
                  className="text-[14px] text-left text-bold border border-gray-400 px-4 py-1"
                >
                  {ykx?.name}
                </td>
                <td className="text-[14px] text-left text-bold border border-gray-400 px-4 py-1">
                  {ykx?.tonna} tn : {(ykx?.tonna * 1000) / 50}-qop
                </td>

                <td
                  onClick={() => {
                    console.log(
                      calculateProductTotals(
                        data?.ykx?.filter(
                          (el) =>
                            moment(el?.date).format("DD.MM.YYYY") ===
                            moment(ykx?.date).format("DD.MM.YYYY")
                        )
                      )
                    );
                  }}
                  className="text-[14px] text-left text-bold border border-gray-400 px-4 py-1"
                >
                  <Tooltip
                    sx={{ fontSize: "10px" }}
                    className="text-[14px]"
                    title={
                      <div>
                        <h1>{moment(ykx?.date).format("DD.MM.YYYY")}</h1>
                        {Object.entries(
                          calculateProductTotals(
                            data?.ykx?.filter(
                              (el) =>
                                moment(el?.date).format("DD.MM.YYYY") ===
                                moment(ykx?.date).format("DD.MM.YYYY")
                            )
                          )
                        ).map((el) => {
                          return (
                            <div>
                              <h2>
                                {el[0]}: {el[1] + " tn"}
                              </h2>
                            </div>
                          );
                        })}
                      </div>
                    }
                  >
                    {moment(ykx?.date).format("DD.MM.YYYY")}
                  </Tooltip>
                </td>
                <td className="text-[14px] text-left text-bold border border-gray-400 px-4 py-1">
                  <Tooltip
                    sx={{ fontSize: "10px" }}
                    className="text-[14px]"
                    title={ykx?.comment}
                  >
                    {ykx?.comment?.length > 5
                      ? ykx?.comment?.slice(0, 6) + "..."
                      : ykx?.comment}
                    {/* {ykx?.comment} */}
                  </Tooltip>
                </td>
                <td className="text-[14px] text-left text-bold border border-gray-400 px-4 py-1 flex gap-2">
                  <CustomerActions
                    actions={[
                      {
                        type: "group",
                        key: "info",
                        label: (
                          <div
                            className=" block w-[100%] flex items-center justify-start gap-2 "
                            rel="noopener noreferrer"
                          >
                            <TbEyeEdit className="font-[18px]" />{" "}
                            <span className="text-[18px]">
                              {ykx?.created_at.split("T")[0]}{" "}
                              {ykx?.created_at.split("T")[1].split(".")[0]}
                            </span>
                          </div>
                        ),
                      },
                      {
                        type: "group",
                        key: "info",
                        label: (
                          <div
                            className=" block w-[100%] flex items-center justify-start gap-2 "
                            rel="noopener noreferrer"
                          >
                            <IoPersonAddOutline className="font-[18px]" />{" "}
                            <span className="text-[18px]">
                              {ykx?.written_by}
                            </span>
                          </div>
                        ),
                      },
                      {
                        type: "divider",
                      },
                      {
                        key: "1",
                        disabled: ykx?.is_dk,
                        label: (
                          <div
                            className=" block w-[100%] flex items-center justify-start gap-2 "
                            rel="noopener noreferrer"
                            onClick={() => {
                              navigator.clipboard
                                .writeText(
                                  window.location.origin + "/kocha/" + ykx?.id
                                )
                                .then(() => message.success("Copied!"))
                                .catch(() => message.error("Failed to copy"));
                              // `[Click to see](${link})`
                            }}
                          >
                            <BsCopy
                              // style={{
                              //   color: "#38BDF8",
                              // }}
                              className="font-[30px]"
                            />
                            Copy link
                          </div>
                        ),
                      },
                      {
                        key: "5",
                        disabled: ykx?.is_dk,
                        label: (
                          <div
                            className=" block w-[100%] flex items-center justify-start gap-2 "
                            rel="noopener noreferrer"
                            onClick={() => {
                              if (ykx?.is_dk) return;
                              setColorYKX(ykx?.id);
                              setColorModalOpen(true);
                            }}
                          >
                            <IoColorPaletteOutline
                              // style={{
                              //   color: "#38BDF8",
                              // }}
                              className="font-[30px]"
                            />
                            color{" "}
                            <button
                              onClick={() => {
                                // colorSetting(col, colorYKX);
                              }}
                              style={{
                                background: ykx?.bgColor
                                  ? ykx?.bgColor
                                  : "#fff",
                              }}
                              className={
                                " w-[20px] h-[20px] rounded-sm  sm:rounded-md "
                              }
                            ></button>
                          </div>
                        ),
                      },
                      {
                        key: "6",
                        // disabled: true,
                        label: (
                          <div
                            className=" block w-[100%] flex items-center justify-start gap-2 "
                            rel="noopener noreferrer"
                            onClick={() => {
                              archiveYKX(ykx?.id, ykx?.is_dk);
                            }}
                          >
                            <MdOutlineUnarchive className="font-[30px]" />
                            {ykx?.is_dk ? "Arxivdan chiqarish" : "Arxivlash"}
                          </div>
                        ),
                      },
                      {
                        type: "divider",
                      },
                      {
                        key: "7",
                        disabled: ykx?.is_dk,
                        label: (
                          <div
                            className=" block w-[100%] flex items-center justify-start gap-2 "
                            rel="noopener noreferrer"
                            onClick={() => {
                              if (ykx?.is_dk) return;
                              // setIsModalOpen(true);
                              navigate(location.pathname + "?" + ykx?.id, {
                                replace: true,
                              });
                              setIsModalOpenEdit(true);
                            }}
                          >
                            <CiEdit className="font-[30px]" /> O'zgartirish
                          </div>
                        ),
                      },
                      {
                        key: "8",
                        disabled: ykx?.is_dk,
                        label: (
                          <Popconfirm
                            disabled={ykx?.is_dk}
                            title="O'chirish"
                            description={
                              `'${ykx?.id}'` +
                              " O'chirishga ishonchingiz komilmi?"
                            }
                            onConfirm={() => {
                              if (ykx?.is_dk) return;
                              deleteYKX(ykx?.id);
                            }}
                            // onCancel={cancel}
                            okText="Yes"
                            cancelText="No"
                          >
                            <div
                              className=" block w-[100%] flex items-center justify-start gap-2 text-[red]"
                              rel="noopener noreferrer"
                            >
                              <MdDeleteOutline className="font-[30px]" />{" "}
                              O'chirish
                            </div>
                          </Popconfirm>
                        ),
                      },
                    ]}
                  />
                </td>
              </tr>
            );
          })}
      </table>
    </div>
  );
}
